<template>
  <div class="upload">
    <input
      ref="input"
      class="hidden"
      type="file"
      :multiple="multiple"
      :accept="accept"
      v-on:change="handleChange"
    >
    <div
      v-if="files.length > 0"
      :class="{ 'files-container-multiple': multiple }"
    >
      <div
        class="file"
        v-for="(file, index) in files"
        :key="file.name"
      >
        <span 
          class="file-container"
          v-on:click="() => handleOpen(file)"
        >
          {{ file.name }}
        </span>
        <Icon
          class="trash"
          type="md-trash"
          :size="18"
          v-on:click="() => handleDelete(file, index)"
        />
      </div>
    </div>
    <Button 
      v-if="(!multiple && files.length === 0) || multiple"
      v-on:click="handleSelect"
    >
      Добавить
    </Button>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    multiple: Boolean,
    accept: String,
    max: Number,
    unit: String
  },
  data() {
    return {
      files: !!this.value ? this.value : []
    }
  },
  methods: {
    handleSelect() {
      this.$refs.input.click();
    },
    handleChange() {
      for (let i = 0; i < this.$refs.input.files.length; i++) {
        const file = this.$refs.input.files[i];

        if(file.size > this.max) {
          this.$Message.error({
            content: 'Размер файла не должен превышать ' + this.unit,
            duration: 3
          });

          continue;
        }

        const includes = this.files.some(
          e => e.name === file.name
        );

        if(!includes) this.files.push(file);
      }

      this.$refs.input.value = "";

      this.$emit("input", this.files);
    },
    handleDelete(file, index) {
      this.$Modal.confirm({
        title: 'Удаление',
        content: 'Вы уверены, что хотите удалить данный файл?',
        onOk: () => {
          this.files.splice(index, 1);

          this.$emit("input", this.files);
        }
      });
    },
    handleOpen(file) {
      if(file.url) window.open(file.url, '_blank');
    }
  }
}
</script>

<style scoped>
.upload {
  display: inline-block;
  width: 100%;
}
.hidden {
  display: none;
}
.files-container-multiple {
  margin-bottom: 8px;
}
.file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.file-container {
  cursor: pointer;

  flex: 1;

  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 4px 7px;
  transition: border .2s ease-in-out;

  height: 32px;

  font-size: 12px;
  line-height: 2;

  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.file-container:hover {
  border-color: #58A1F3;
}
.file:last-child {
  margin-bottom: 0;
}
.trash {
  padding-left: 10px;
  padding-right: 4px;
  cursor: pointer;
}
</style>